import { queryFilter } from 'utils/proptypes';
import base from './baseApi';
import { createSearchParams } from 'react-router';
import { omit, omitBy } from 'lodash';
import type { MarketSettings } from 'src/types/market.type';

const { urls, methods, execute } = base();

export type UpdateSiteRequest = {
   id: string;
   slug?: string;
   code?: string;
   phoneNumber?: string;
   displayName?: string;
   primaryDomain?: string;
   envDomains?: Record<string, unknown>;
   visualBranding?: Record<string, unknown>;
   defaultLandingVideo?: Record<string, unknown>;
   email?: string;
   supportEmail?: string;
   /** NPT-2083 — '' turns the chat widget off. */
   helpScoutBeaconId?: string;
   organizationIds?: string[];
   /** NPT-2051 — null clears (the site falls back to DEFAULT_MARKET). */
   market?: Partial<MarketSettings> | null;
};

const getSites = async (queryFilter: queryFilter) => {
   const method = methods.GET;
   const initParams: any = omitBy(queryFilter, v => v === '');
   const params = createSearchParams(initParams);

   const url = `${urls.site.getSites}?${params.toString()}`;
   const response = await execute(method, url);

   return response;
};

const getSiteById = async (id: string) => {
   const method = methods.GET;
   const url = urls.site.getSite.replace(':id', id);
   const response = await execute(method, url);

   return response;
};

const updateSite = (payload: UpdateSiteRequest) => {
   const { id } = payload;

   const method = methods.PUT;
   const url = urls.site.update.replace(':id', id);
   const response = execute(method, url, { authorization: true }, omit(payload, 'id'));

   return response;
};

export { getSites, getSiteById, updateSite };
